import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./EditUserApplcation.module.scss";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  notification,
  Row,
  Select,
  Table,
  Tooltip,
  Upload,
} from "antd";
import { useForm } from "antd/es/form/Form";
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PlusCircleOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { ICreateApplicationResponse, IRouteCountries } from "../../types";
import type { TableColumnsType, UploadProps } from "antd";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  addMessage,
  deleteApplicationFiles,
  deleteApplicationRoutes,
  getApplicationDetails,
  getApplicationsList,
  updateApplication,
} from "../../redux/ApplicationSlice";
import { UploadFile } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import moment from "moment";
import Loading from "../../components/Loading/Loading";
import { useTranslation } from "react-i18next";
import { ColumnsType } from "antd/es/table";
import { getStatusTag } from "../../utils/functions";
import MobileDeclarantTable from "../../components/MobileDeclarantTable/MobileDeclarantTable";

const { Option } = Select;

const props: UploadProps = {
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  onChange({ file, fileList }) {
    if (file.status !== "uploading") {
      console.log(file, fileList);
    }
  },
  beforeUpload: () => false,
  defaultFileList: [],
};

export interface UploadTableType {
  id: string;
  number?: number;
  name: string;
  upload_file?: string;
}

const uploadTableData = [
  { id: "invoice", name: "Инвойс (документ сопровождающий груз)" },
  {
    id: "customs_declaration_files",
    name: "Экспортная/ Транзитная декларация",
  },
  { id: "transport", name: "Транспортный документ (CMR, Bill of Lading,...)" },
  { id: "tech_passport_file", name: "Техпаспорт" },
  { id: "drivers_passport", name: "Паспорт водителя" },
  { id: "supporting", name: "Прочая документация" },
];

export interface EditTableType {
  number: number;
  application_number?: string;
  created_at?: string;
  status?: string;
  comments?: [];
  price?: number | string;
  status_change_dates?: string;
  user?: string;
  actions: string;
}

const EditUserApplication: React.FC = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [form] = useForm();
  const params = useParams();
  const application = useSelector(
    (state: RootState) => state.application.application,
  );
  const countries = useSelector(
    (state: RootState) => state.application.countries,
  );

  const [files, setFiles] = useState<Record<string, UploadFile<any>[]>>({});
  const loading = useSelector((state: RootState) => state.application.loading);
  const user = useSelector((state: RootState) => state.user.user);
  const [api, contextHolder] = notification.useNotification();
  const [changedValues, setChangedValues] =
    useState<Partial<ICreateApplicationResponse>>();
  const [isDisabled, setIsDisabled] = useState<boolean>(
    application?.status === "incomplete" ? true : false,
  );
  const currentPage = useSelector(
    (state: RootState) => state.application.currentPage,
  );
  const [deletedRouteIds, setDeletedRouteIds] = useState<number[]>([]);
  const [deletedFilesIds, setDeletedFilesIds] = useState<number[]>([]);

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };
  const dispatch: AppDispatch = useDispatch();
  const [phone, setPhone] = useState(user?.phone);
  const managerServices = useSelector(
    (state: RootState) => state.application.managerServices,
  );

  const data: EditTableType[] = [
    {
      number: 1,
      application_number: application?.application_number,
      created_at: application?.created_at,
      status: application?.status,
      comments: application?.comments,
      price: application?.price ? application.price : "-",
      user: "",
      actions: t("Редактирование"),
    },
  ];

  const columns: ColumnsType<EditTableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Статус"),
      dataIndex: `status`,
      width: 600,
      align: "center",
      render: (text) => <div>{getStatusTag(text, "lg", t)}</div>,
    },
    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Дата регистрации заявки"),
      dataIndex: `registration_date`,
      width: 600,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },

    {
      title: t("Cумма к оплате, $"),
      dataIndex: `price`,
      width: 600,
      align: "center",
    },
    {
      title: t("Дата изменения статуса"),
      dataIndex: `status_change_dates`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },
  ];

  const columns2: ColumnsType<EditTableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 100,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Дата регистрации заявки"),
      dataIndex: `registration_date`,
      width: 180,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Статус"),
      dataIndex: `status`,
      width: 150,
      align: "center",
      render: (text) => <div>{getStatusTag(text, "lg", t)}</div>,
    },
    {
      title: t("Комментарии"),
      dataIndex: `comments`,
      width: 400,
    },
    {
      title: t("Дата изменения статуса"),
      dataIndex: `status_change_dates`,
      width: 200,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
  ];

  useEffect(() => {
    if (application) {
      form.setFieldsValue({
        shipper_country: application.shipper_country,
        destination_country: application.destination_country,
        contact_phone: application.contact_phone,
        vehicle_number: application.vehicle_number,
        contact_email: application.contact_email,
        status: application.status,
        created_at: application.created_at,
        driver_name: application.driver_name,
        container_number:
          application.container_number === "undefined"
            ? "-"
            : application.container_number,

        customs_seal_numbers:
          application.customs_seal_numbers === "undefined"
            ? "-"
            : application.customs_seal_numbers,
        routes: application.routes?.map((it) => ({
          id: it.id,
          transit_country: it.transit_country,
          entry_customs_checkpoint: it.entry_customs_checkpoint,
          exit_customs_checkpoint: it.exit_customs_checkpoint,
          partner_company: it.service_owner,
          services: it.services.map((it) => ({
            value: it.service_id,
            lable: it.service_name,
          })),
          status: it.status,
        })),
      });
    }

    if (application?.files && Array.isArray(application.files)) {
      const mappedFiles: Record<string, UploadFile<any>[]> = {};

      application.files.forEach((f) => {
        if (!mappedFiles[f.file_type]) {
          mappedFiles[f.file_type] = [];
        }
        mappedFiles[f.file_type].push({
          uid: String(f.id),
          name: f.file_name_display || f.file_name,
          status: "done",
          url: f.file,
        });
      });

      setFiles(mappedFiles);

      form.setFieldsValue(mappedFiles);
    }
  }, [application]);

  const handleChange =
    (recordId: string) => (info: { fileList: UploadFile<any>[] }) => {
      setFiles((prev) => ({
        ...prev,
        [recordId]: info.fileList,
      }));
      form.setFieldsValue({
        [recordId]: info.fileList,
      });
    };

  const UploadTableColums: TableColumnsType<UploadTableType> = [
    { dataIndex: "number", title: "№", width: 50, align: "center" },
    { dataIndex: "name", title: "Наименование документа", width: 500 },
    {
      title: "Прикрепленные документы",
      width: 300,
      dataIndex: "upload",
      render: (_: any, record: UploadTableType) => {
        return (
          <div className={s.table_upload}>
            <Form.Item
              name={record.id}
              rules={[
                {
                  validator: (_, value) =>
                    value && value.length > 0
                      ? Promise.resolve()
                      : Promise.reject(new Error("Загрузите файл")),
                },
              ]}
            >
              <Upload
                {...props}
                beforeUpload={() => false}
                fileList={files[record.id] || []}
                onChange={handleChange(record.id)}
                onRemove={(file) => {
                  if (!file.originFileObj) {
                    setDeletedFilesIds((prev) => [...prev, Number(file.uid)]);
                  }

                  setFiles((prev) => {
                    const currentFiles = prev[record.id] || [];
                    const newFiles = currentFiles.filter(
                      (f) => f.uid !== file.uid,
                    );

                    form.setFieldsValue({
                      [record.id]: newFiles,
                    });

                    return {
                      ...prev,
                      [record.id]: newFiles,
                    };
                  });

                  return true;
                }}
              >
                {!isDisabled && (
                  <Button icon={<UploadOutlined />} className={s.upload_btn}>
                    Upload
                  </Button>
                )}
              </Upload>
            </Form.Item>
          </div>
        );
      },
    },
  ];

  //   if (file.id) {
  //     setDeletedFiles((prev) => [...prev, file.id]);
  //   }

  //   setFiles((prev) => ({
  //     ...prev,
  //     [recordId]: (prev[recordId] || []).filter((f) => f.uid !== file.uid),
  //   }));

  //   return false;
  // };

  const onValuesChange = (
    changed: Partial<ICreateApplicationResponse>,
    allValues: ICreateApplicationResponse,
  ) => {
    setChangedValues((prev) => {
      const newValues: Partial<ICreateApplicationResponse> = { ...prev };

      if (changed.routes && Array.isArray(changed.routes)) {
        const prevRoutes = prev?.routes || [];

        newValues.routes = allValues.routes.map((row, index) => {
          const prevRowChanges = prevRoutes[index] || {};
          const changedRow =
            (changed.routes as Partial<IRouteCountries>[])[index] || {};

          return { ...prevRowChanges, ...changedRow };
        });
      }

      Object.keys(changed).forEach((key) => {
        if (key !== "routes") {
          (newValues as any)[key] = (changed as any)[key];
        }
      });

      return newValues;
    });
  };

  const updateForm = async () => {
    try {
      const data = new FormData();

      if (changedValues) {
        if (changedValues.routes?.length) {
          const changedRoutes = changedValues.routes
            .map((row, index) => {
              const originalRow = application?.routes[index];

              if (!originalRow) {
                const cleanRow: any = {};

                for (const key in row) {
                  const value = (row as any)[key];
                  if (value && value !== undefined && value !== null) {
                    cleanRow[key] = value?.value ?? value;
                  }
                }

                return Object.keys(cleanRow).length > 0 ? cleanRow : null;
              }

              const updatedFields: any = {};
              for (const key in row) {
                const typedKey = key as keyof typeof row; // для TS
                const newValue = (row[typedKey] as any)?.value ?? row[typedKey];
                const oldValue =
                  (originalRow[typedKey] as any)?.id ?? originalRow[typedKey];

                if (newValue !== oldValue) {
                  updatedFields[typedKey] = newValue;
                }
              }

              if (Object.keys(updatedFields).length > 0) {
                return { id: originalRow.id, ...updatedFields };
              }
              return null;
            })
            .filter(Boolean);

          if (changedRoutes.length > 0) {
            data.append("routes", JSON.stringify(changedRoutes));
          }
        }
        for (const [key, value] of Object.entries(changedValues)) {
          if (key !== "routes") {
            data.append(key, JSON.stringify(value));
          }
        }
      }

      if (deletedRouteIds?.length > 0) {
        const res = await dispatch(
          deleteApplicationRoutes({
            id: Number(params.id),
            route_ids: deletedRouteIds,
          }),
        );
      }

      if (deletedFilesIds.length) {
        const res = await dispatch(
          deleteApplicationFiles({
            id: Number(params.id),
            file_ids: deletedFilesIds,
          }),
        );

        if (res.type === "applications/deleteApplicationFiles/fulfilled") {
          setDeletedFilesIds([]);
        }
      }

      Object.entries(files).forEach(([fieldName, fileList]) => {
        fileList.forEach((fileItem) => {
          if (fileItem.originFileObj) {
            data.append(fieldName, fileItem.originFileObj);
          }
        });
      });

      const res = await dispatch(
        updateApplication({ id: Number(params.id), formData: data }),
      );

      if (res.type === "applications/updateApplication/fulfilled") {
        dispatch(getApplicationDetails(Number(params.id)));
        openNotification(true, "Вы обновили заявление!", "success")();

        await dispatch(
          addMessage({
            application: Number(params.id),
            content: t(
              `Данные откорректированы, заявка готова к дальнейшему рассмотрению`,
            ),
            application_status: "corrected",
          }),
        );
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const addNewRoute = () => {
    const routes = form.getFieldValue("routes") || [];
    form.setFieldsValue({
      routes: [
        ...routes,
        {
          transit_country: undefined,
          entry_customs_checkpoint: undefined,
          exit_customs_checkpoint: undefined,
          partner_company: undefined,
          service: undefined,
          status: "incomplete",
        },
      ],
    });
  };

  const deleteRoute = (index: number, remove: (index: number) => void) => {
    const currentRoutes = form.getFieldValue("routes") || [];
    const removed = currentRoutes[index];

    if (removed?.id) {
      setDeletedRouteIds((prev) => [...prev, removed.id]);
    }

    remove(index);
  };

  return (
    <div className={s.wrapper}>
      {contextHolder}
      {width > 700 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <Link
          to="/applications"
          className={s.back}
          onClick={() => dispatch(getApplicationsList(currentPage))}
        >
          <ArrowLeftOutlined className={s.backIcon} /> {t("Назад")}
        </Link>
        <div className={s.table}>
          {width > 700 ? (
            <Table<EditTableType>
              bordered
              pagination={false}
              columns={
                application?.status === "incomplete" ? columns2 : columns
              }
              className="table"
              dataSource={data?.map((it, index) => ({
                number: index + 1,
                application_number: it?.application_number,
                registration_date: moment(it?.created_at).format(
                  "DD.MM.YYYY - HH:mm",
                ),
                status: it?.status,
                comments: it?.comments,
                price:
                  application?.price && Number(application?.price) > 0
                    ? application.price
                    : "-",

                user: it?.user,
                actions: it.actions,
              }))}
            />
          ) : (
            <MobileDeclarantTable
              dataSource={data?.map((it) => ({
                ...it,
              }))}
            />
          )}
        </div>
        <div className={s.form}>
          <Form
            layout="vertical"
            className={"create_application"}
            form={form}
            onFinish={updateForm}
            onValuesChange={onValuesChange}
          >
            <Row gutter={[10, 4]}>
              <Col span={width > 900 ? 6 : 24}>
                <Form.Item
                  name="shipper_country"
                  label="Страна грузоотправитель"
                  initialValue={{
                    value: application?.shipper_country,
                    label: application?.shipper_country_name,
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Выберите страну грузоотправителя",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className={s.select}
                    disabled={isDisabled}
                    placeholder={"Выберите страну"}
                    options={countries?.map((it) => ({
                      value: it?.id,
                      label: it?.transit_country_name,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 24}>
                <Form.Item
                  name="destination_country"
                  label="Страна грузополучатель"
                  initialValue={{
                    value: application?.destination_country,
                    label: application?.destination_country_name,
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Выберите страну грузоотправителя",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className={s.select}
                    placeholder={"Выберите страну"}
                    options={countries?.map((it) => ({
                      value: it?.id,
                      label: it?.transit_country_name,
                    }))}
                    onChange={() => {
                      form.setFieldValue("company", undefined);
                      form.setFieldValue("service", undefined);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  shouldUpdate
                  label={"Региональный представитель"}
                  rules={[
                    { required: true, message: "Региональный представитель" },
                  ]}
                >
                  {({ getFieldValue }) => {
                    const destinationCountryId = getFieldValue(
                      "destination_country",
                    );
                    const country = managerServices?.find(
                      (c) => c.id === destinationCountryId,
                    );

                    return (
                      <Form.Item
                        name="company"
                        noStyle
                        initialValue={{
                          value:
                            application?.company_details?.registered_country,
                          label: `${application?.company_details?.registered_country} - ${application?.company_details?.company_name}`,
                        }}
                        rules={[
                          {
                            required: true,
                            message: "Региональный представитель",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          className={s.select}
                          placeholder={"Региональный представитель"}
                          onChange={() => {
                            form.setFieldValue("service", undefined);
                          }}
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  shouldUpdate
                  label="Услуги"
                  rules={[{ required: true, message: "Выберите услугу" }]}
                >
                  {({ getFieldValue }) => {
                    const selectedCompanyId = getFieldValue("company");

                    return (
                      <Form.Item
                        name="service"
                        noStyle
                        rules={[{ required: true, message: "Выберите услугу" }]}
                        initialValue={{
                          value: application?.service_details?.id,
                          label: `$${application?.service_details?.price} - ${application?.service_details?.service_name}`,
                        }}
                      >
                        <Select
                          showSearch
                          className={s.select}
                          placeholder={"Услуги"}
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[8, 4]}>
              <Form.List
                name="routes"
                initialValue={
                  Array.isArray(application?.routes)
                    ? application?.routes.map((it) => ({
                        id: it.id,
                        transit_country: {
                          value: it.transit_country,
                          label: it.transit_country_name,
                        },
                        entry_customs_checkpoint: {
                          value: it.entry_customs_checkpoint,
                          label: it.entry_customs_name,
                        },
                        exit_customs_checkpoint: {
                          value: it.exit_customs_checkpoint,
                          label: it.exit_customs_name,
                        },
                        partner_company: {
                          value: it.service_owner,
                          label: `${it.transit_country_name} -  ${it.service_owner_email}`,
                        },
                        // service: {
                        //   value: it.service,
                        //   label: `$${it.service_price} -  ${it.service_name}`,
                        // },
                        status: it.status,
                      }))
                    : []
                }
              >
                {(fields, { remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <div
                        className={
                          Array.isArray(fields) && fields?.length > 0
                            ? s.dynamic_fields
                            : ""
                        }
                      >
                        <Col span={2}>
                          <Form.Item
                            {...restField}
                            name={[name, "status"]}
                            label={"Статус"}
                            rules={[
                              { required: true, message: "Missing first name" },
                            ]}
                          >
                            <div style={{ marginTop: "5px" }}>
                              {getStatusTag(
                                form.getFieldValue(["routes", name, "status"]),
                                "md",
                                t,
                              )}
                            </div>
                          </Form.Item>
                        </Col>
                        <Col span={3}>
                          <Form.Item
                            {...restField}
                            name={[name, "transit_country"]}
                            label={"Страна транзита"}
                            rules={[
                              { required: true, message: "Страна транзита" },
                            ]}
                          >
                            <Select
                              showSearch
                              //disabled={isDisabled}
                              className={s.select}
                              placeholder={"Выберите страну"}
                              options={countries?.map((it) => ({
                                value: it?.id,
                                label: it?.transit_country_name,
                              }))}
                              onChange={() => {
                                form.setFields([
                                  {
                                    name: [
                                      "routes",
                                      name,
                                      "entry_customs_checkpoint",
                                    ],
                                    value: undefined,
                                  },
                                  {
                                    name: [
                                      "routes",
                                      name,
                                      "exit_customs_checkpoint",
                                    ],
                                    value: undefined,
                                  },
                                  {
                                    name: ["routes", name, "partner_company"],
                                    value: undefined,
                                  },
                                  {
                                    name: ["routes", name, "service"],
                                    value: undefined,
                                  },
                                ]);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={5}>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.routes?.[name]?.transit_country !==
                              currentValues.routes?.[name]?.transit_country
                            }
                          >
                            {({ getFieldValue }) => {
                              const routes = (getFieldValue("routes") ||
                                []) as any[];
                              const route = routes[name];
                              const selectedCountryId = route?.transit_country;
                              const selectedCountry = countries?.find(
                                (c) => c.id === selectedCountryId,
                              );

                              return (
                                <Form.Item
                                  {...restField}
                                  name={[name, "entry_customs_checkpoint"]}
                                  label="Въeздной таможенный пункт"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Выберите въездной таможенный контрольно-пропускной пункт",
                                    },
                                  ]}
                                >
                                  <Select
                                    placeholder={
                                      "Выездной таможенный контрольно - пропускной пункт"
                                    }
                                    className={s.select}
                                    popupClassName={"customSelectDropdown"}
                                    options={selectedCountry?.bordered_countries.map(
                                      (it) => ({
                                        label: (
                                          <Divider plain orientation="center">
                                            <span
                                              className={
                                                s.bordered_countries_names
                                              }
                                            >
                                              {it.bordered_country_names}
                                            </span>
                                          </Divider>
                                        ),
                                        title: it?.bordered_country_names,
                                        options: it.offices.map((el) => ({
                                          label: (
                                            <span className={s.post_name}>
                                              {el.customs_name}
                                            </span>
                                          ),
                                          value: el.id,
                                        })),
                                      }),
                                    )}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>
                        </Col>
                        <Col span={5}>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.routes?.[name]?.transit_country !==
                              currentValues.routes?.[name]?.transit_country
                            }
                          >
                            {({ getFieldValue }) => {
                              const routes = (getFieldValue("routes") ||
                                []) as any[];
                              const route = routes[name];
                              const selectedCountryId = route?.transit_country;
                              const selectedCountry = countries?.find(
                                (c) => c.id === selectedCountryId,
                              );

                              return (
                                <Form.Item
                                  {...restField}
                                  name={[name, "exit_customs_checkpoint"]}
                                  label="Выeздной таможенный пункт"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        "Выберите въездной таможенный контрольно-пропускной пункт",
                                    },
                                  ]}
                                >
                                  <Select
                                    placeholder={
                                      "Выездной таможенный контрольно - пропускной пункт"
                                    }
                                    className={s.select}
                                    popupClassName={"customSelectDropdown"}
                                    options={selectedCountry?.bordered_countries.map(
                                      (it) => ({
                                        label: (
                                          <Divider plain orientation="center">
                                            <span
                                              className={
                                                s.bordered_countries_names
                                              }
                                            >
                                              {it.bordered_country_names}
                                            </span>
                                          </Divider>
                                        ),
                                        title: it?.bordered_country_names,
                                        options: it.offices.map((el) => ({
                                          label: (
                                            <span className={s.post_name}>
                                              {el.customs_name}
                                            </span>
                                          ),
                                          value: el.id,
                                        })),
                                      }),
                                    )}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.routes?.[name]?.transit_country !==
                              currentValues.routes?.[name]?.transit_country
                            }
                          >
                            {({ getFieldValue }) => {
                              const routes = (getFieldValue("routes") ||
                                []) as any[];
                              const route = routes[name];
                              const selectedCountryId = route?.transit_country;
                              const selectedCountryName = managerServices?.find(
                                (c) => c.id === selectedCountryId,
                              )?.transit_country_name;
                              // const selectedManager = managerServices?.find(
                              //   (c) => c.id === selectedCountryId
                              // )?.companies;
                              return (
                                <Form.Item
                                  {...restField}
                                  name={[name, "partner_company"]}
                                  label={"Региональный представитель"}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Выберите компанию партнера",
                                    },
                                  ]}
                                >
                                  <Select
                                    className={s.select}
                                    placeholder="Компания"
                                    // options={selectedManager?.map((it) => ({
                                    //   value: it?.id,
                                    //   label: (
                                    //     <div>
                                    //       {`${selectedCountryName} -
                                    //         ${it.company_name}`}
                                    //     </div>
                                    //   ),
                                    // }))}
                                    onChange={() => {
                                      form.setFieldValue(
                                        ["routes", name, "service"],
                                        undefined,
                                      );
                                    }}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>
                        </Col>

                        <Col span={5}>
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.routes?.[name]?.partner_company !==
                              currentValues.routes?.[name]?.partner_company
                            }
                          >
                            {({ getFieldValue }) => {
                              const routes = getFieldValue("routes") || [];
                              const route = routes?.[name];
                              const selectedCountryId = route?.transit_country;
                              const selectedCompanyId = route?.partner_company;
                              const country = managerServices?.find(
                                (c) => c.id === selectedCountryId,
                              );

                              // const company = country?.companies?.find(
                              //   (comp) => comp.id === selectedCompanyId
                              // );

                              return (
                                <Form.Item
                                  {...restField}
                                  name={[name, "services"]}
                                  label={"Услуги"}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Услуги",
                                    },
                                  ]}
                                >
                                  <Select
                                    popupClassName={"customSelectDropdown"}
                                    className={s.select}
                                    placeholder="Услуги"
                                    mode="multiple"
                                    // options={company?.services?.map((it) => ({
                                    //   label: `${it.price}$ - ${it.service_name}`,
                                    //   value: it.id,
                                    // }))}
                                  />
                                </Form.Item>
                              );
                            }}
                          </Form.Item>
                        </Col>
                        <Col className={s.btns_wrapper}>
                          <div className={s.btns_wrapper_inner}>
                            {fields.length > 1 && (
                              <Tooltip
                                placement="topRight"
                                title={"Удалить ряд"}
                                color={"gray"}
                              >
                                <CloseCircleOutlined
                                  className={s.close_icon}
                                  onClick={() => deleteRoute(name, remove)}
                                />
                              </Tooltip>
                            )}
                            <Tooltip
                              placement="topRight"
                              title={"Добавить ряд"}
                              color={"gray"}
                            >
                              <PlusCircleOutlined
                                className={s.plus_icon}
                                onClick={() => addNewRoute()}
                              />
                            </Tooltip>
                          </div>
                        </Col>
                      </div>
                    ))}

                    {/* )) */}
                    {/* } */}
                  </>
                )}
              </Form.List>
            </Row>

            <Row gutter={[10, 4]}>
              <Col span={width > 900 ? 6 : 24}>
                <Form.Item
                  name="vehicle_number"
                  label="№ транспортного средства"
                  rules={[
                    {
                      required: true,
                      message: "Введите № транспортного средства",
                    },
                  ]}
                >
                  <input
                    disabled={isDisabled}
                    placeholder="Введите № транспортного средства"
                    className={s.input}
                  />
                </Form.Item>
              </Col>

              <Col span={width > 900 ? 6 : 20}>
                <Form.Item name="container_number" label="№ контейнера">
                  <input
                    disabled={isDisabled}
                    placeholder="Укажите № контейнера"
                    className={s.input}
                  />
                </Form.Item>
              </Col>

              <Col span={width > 900 ? 12 : 24}>
                <Form.Item
                  name="customs_seal_numbers"
                  label="Номера таможенных пломб"
                >
                  <textarea
                    disabled={isDisabled}
                    placeholder="Укажите номера таможенных пломб"
                    className={s.input}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[10, 4]}>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item name="driver_name" label={"ФИО (Водителя)"}>
                  <input
                    value={phone}
                    className={s.input}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="contact_phone"
                  label={
                    width > 1091
                      ? "Контактный телефон (Водителя)"
                      : "Телефон (Водителя)"
                  }
                >
                  <PhoneInput
                    disabled={isDisabled}
                    defaultCountry="md"
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    className={s.phone_input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="contact_email"
                  label={
                    width > 1091
                      ? "Контактный Email (Водителя)"
                      : "Email (Водителя)"
                  }
                >
                  <input
                    placeholder="Введите Email"
                    className={s.input}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </Col>
            </Row>
            <h2 className={s.h2} style={{ width: "100%" }}>
              Прикрепленные документы
            </h2>
            <Table<UploadTableType>
              columns={UploadTableColums}
              pagination={false}
              bordered
              dataSource={uploadTableData.map((it, index) => ({
                ...it,
                number: index + 1,
              }))}
            ></Table>
            <button className={s.btn} type="submit">
              Обновить заявку
            </button>
          </Form>
        </div>
      </div>

      <Footer />
      {loading ? (
        <div className={s.loader}>
          <Loading loading={loading} />
        </div>
      ) : null}
    </div>
  );
};

export default EditUserApplication;
